import fjGallery from "flickr-justified-gallery";

fjGallery(document.querySelectorAll('.fj-gallery'), {
    itemSelector: '.fj-gallery-item'
  });

import '../sass/components/_albums.scss';